let resumeData = {
    "imagebaseurl":"https://ivy555.github.io/",
    "name": "Hariz Zariman",
    "firstname": "Hariz",
    "lastname": "Zariman",
    "role": "Full Stack Developer",
    "linkedinId":"Your ID",
    "skypeid": "Your skypeid",
    "roleDescription": "I like to learn and create applications in various parts of software development and like to learn about new technologies, write technical articles or simply play games in my free time.",
    "socialLinks":[
    {
    "name":"linkedin",
    "url":"https://www.linkedin.com/in/hzariman/",
    "className":"fa fa-linkedin"
    },
    {
    "name":"github",
    "url":"http://github.com/hzariman",
    "className":"fa fa-github"
    }
    ],
    "aboutme":"I am currently working as a Software Engineer at Google. I recently graduated from the University of California, San Diego with a B.S. in Computer Engineering. I have experience in full‑stack web development, electronic system synthesis, and robotics.",
    "aboutme2" :"In my free time, I enjoy playing golf, skiing and binge watching Netflix!",
    "pfp": "/images/profile_clean.jpg",
    "pfp2x": "/images/profile_clean@2x.jpg",
    "address":"San Diego, CA",
    "website":"https://harizzariman.com/",
    "education":[
    {
    "UniversityName":"University of California, San Diego",
    "Location":"San Diego, CA",
    "Image" : "images/UCSD-Emblem.png",
    "Major":"B.S Computer Engineering",
    "StartDate":"September 2020",
    "EndDate":"Present",
    "Grades":"GPA: 3.79",
    "AdditionalInfo" : "Relevant coursework: Data Structures (Python, Java, C, C++), Theory of Computation, Electrical Circuit Analysis, Computer Vision, Discrete Mathematics, Data Structures & Object-Oriented Design, Computer Organization & Systems Organization, Design & Analysis of Algorithms",
    },
    {
    "UniversityName":"The Alice Smith School",
    "Location":"Kuala Lumpur, Malaysia",
    "Image" : "images/KLASS-Emblem.png",
    "Major":"A Level Qualifications",
    "StartDate":"September 2018",
    "EndDate":"September 2020",
    "Grades":"Mathematics: A | Physics: A | Computer Science: A | Extended Project Qualification: A*",
    "AdditionalInfo" : "Completed the A-Level curriculum for Pearson Edexcel GCE (Mathematics) and AQA GCE (Physics and Computer Science) exam boards. Also completed the Extended Project Qualification (EPQ) in which I investigated the topic 'To what extent can cryptocurrencies replace current everyday monetary transactions'.",
    }
    ],
    "work":[
    {
    "JobTitle": "Software Engineer",
    "CompanyName":"Google",
    "Location":"Mountain View, California",
    "Image" : "images/google-icon.png",
    "StartDate":"January 2025",
    "EndDate":"Present",
    "BriefJD":"Working in Search Evaluation.",
    "Tasks" : [],
    "Skills": ["Java", "Javascript", "Typescript"],
    },
    {
    "JobTitle": "Software Engineering Intern",
    "CompanyName":"AirAsia",
    "Location":"Kuala Lumpur, Malaysia",
    "Image" : "images/AirAsia-Emblem.png",
    "StartDate":"June 2022",
    "EndDate":"September 2022",
    "BriefJD" : "Worked in a small team to develop in-house applications in Agile environment.",
    "Tasks": ["Developed a query filter system when generating reports for a cash advance website.", "Created front-end UI and back-end functionality for generating summary reports", "Resolved database conflicts identified by user support tickets."],
    "Skills": ["Flask", "Angular", "HTML", "CSS", "SQL"],
    }
    ],
    "skillsDescription":"",
    "projects" : [
        {
        "ProjectName" : "Food Booking System Website",
        "StartDate" : "February 2020",
        "EndDate" : "End Date",
        "Image" : "images/projects/klasseats.png",
        "Tasks" : ["Did this", "and that", "and this..."],
        "Skills" : ["Django", "Bootstrap", "SQL"],
        "JD" : "Created a large-scale CRUD web application for high school, allowing students to pre order their food prior to recess and lunch breaks",
        "CustomURL": "klasseats",
        "ProjectCover": "images/mockup/klasseats-mockup.png",
        "ProjectOverview": "KlassEats is my first web development project which creates a system (using HTML/CSS and the Django framework) that aims to allow students within my high-school to pre-order their meals ahead of time. It contains separate user interfaces for the Admin, Staff and Student user roles which contain their respective actions. ",
        "ProjectOverviewImage": "images/mockup/klasseats-browser1.png",
        "AdditionalInfo" : [
            {
                "ProjectOverview" : "KlassEats is my first web development project which creates a system (using HTML/CSS and the Django framework) that aims to allow students within my high-school to pre-order their meals ahead of time. It contains separate user interfaces for the Admin, Staff and Student user roles which contain their respective actions. ",
                "ProjectOverviewImage": "images/mockup/klasseats-browser1.png",
            },
            {
                "ProjectOverview" : "KlassEats is my first web development project which creates a system (using HTML/CSS and the Django framework) that aims to allow students within my high-school to pre-order their meals ahead of time. It contains separate user interfaces for the Admin, Staff and Student user roles which contain their respective actions. ",
                "ProjectOverviewImage": "images/mockup/klasseats-browser1.png",
            },
            {
                "ProjectOverview" : "KlassEats is my first web development project which creates a system (using HTML/CSS and the Django framework) that aims to allow students within my high-school to pre-order their meals ahead of time. It contains separate user interfaces for the Admin, Staff and Student user roles which contain their respective actions. ",
                "ProjectOverviewImage": "images/mockup/klasseats-browser1.png",
            },
        ],
        },
        {
        "ProjectName" : "Online Photoshop Website",
        "StartDate" : "December 2022",
        "EndDate" : "End Date",
        "Image" : "images/projects/photoshop.png",
        "ProjectCover": "images/mockup/photoshop-mockup.png",
        "Tasks" : ["Did this", "and that", "and this..."],
        "Skills" : ["HTML", "CSS", "Javascript"],
        "JD" : "Created a local-first online photoshop web application, allowing users to upload, edit, and download personal images for university coursework",
        "CustomURL": "online-photoshop",
        },
        {
        "ProjectName" : "Autonomous Model Car",
        "StartDate" : "January 2023",
        "EndDate" : "End Date",
        "Image" : "images/UCSD-Emblem.png",
        "ProjectCover": "images/mockup/klasseats-mockup.png",
        "Tasks" : ["Did this", "and that", "and this..."],
        "Skills" : ["ROS2", "Computer Vision", "Embedded Linux", "Python"],
        "JD" : "Designed prototypes for assembling a physical robot car, competed in self-driving races and implemented traffic light reaction and stop sign detection",
        "CustomURL": "autonomous-car",
        },
        {
        "ProjectName" : "SHA256/Bitcoin Hashing RTL Model",
        "StartDate" : "May 2023",
        "EndDate" : "End Date",
        "Image" : "images/UCSD-Emblem.png",
        "ProjectCover": "images/mockup/klasseats-mockup.png",
        "Tasks" : ["Did this", "and that", "and this..."],
        "Skills" : ["SystemVerilog", "Quartus", "Modelsim", "Hardware Optimization"],
        "JD" : "Designed ...",
        "CustomURL": "sha256-bitcoin-hasher",
        },
        {
        "ProjectName" : "Personal Portfolio Website",
        "StartDate" : "June 2023",
        "EndDate" : "End Date",
        "Image" : "images/UCSD-Emblem.png",
        "ProjectCover": "images/mockup/klasseats-mockup.png",
        "Tasks" : ["Did this", "and that", "and this..."],
        "Skills" : ["React.js", "HTML", "CSS"],
        "JD" : "Made this website :)",
        "CustomURL": "portfolio",
        },
    ],
    "skills":[
    {
    "skillname":"HTML5"
    },
    {
    "skillname":"CSS"
    },
    {
    "skillname":"Reactjs"
    }
    ],
    "portfolio":[
    {
    "name":"project1",
    "description":"mobileapp",
    "imgurl":"images/portfolio/phone.jpg"
    },
    {
    "name":"project2",
    "description":"mobileapp",
    "imgurl":"images/portfolio/project.jpg"
    },
    {
    "name":"project3",
    "description":"mobileapp",
    "imgurl":"images/portfolio/project2.png"
    },
    {
    "name":"project4",
    "description":"mobileapp",
    "imgurl":"images/portfolio/phone.jpg"
    }
    ],
    "testimonials":[
    {
    "description":"This is a sample testimonial",
    "name":"Some technical guy"
    },
    {
    "description":"This is a sample testimonial",
    "name":"Some technical guy"
    }
    ]
    }
    export default resumeData